import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/css/index.css';
import App from './App';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { setupAxiosInterceptors } from './service/axios-interceptor';

const AppWrapper = () => {
  const navigate = useNavigate();
  
  React.useEffect(() => {
    setupAxiosInterceptors(navigate);
  }, [navigate]);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppWrapper />
  </BrowserRouter>
);


